import type { BrandSeparationMode } from '@magnetar/admin-api-interfaces'

export const SEPARATION_MODE_LABEL: Record<BrandSeparationMode, string> = {
  none: '不限',
  within_break: '梯次內相鄰不播',
  adjacent_breaks: '相鄰梯次不播',
}

export const SEPARATION_MODE_DESCRIPTION: Record<BrandSeparationMode, string> = {
  none: '同品牌可以連著播。',
  within_break: '同一個梯次裡，這個品牌的素材不會前後相鄰；排不開的那支不播、留痕。',
  adjacent_breaks: '連續兩個梯次不會都有這個品牌，同一梯次內也不相鄰；排不開的那支不播、留痕。',
}

export const SEPARATION_MODES: BrandSeparationMode[] = ['none', 'within_break', 'adjacent_breaks']
